import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

type GetStartedModalContextValue = {
  show: boolean;
  openGetStartedModal: () => void;
  closeGetStartedModal: () => void;
};

const GetStartedModalContext = createContext<GetStartedModalContextValue | null>(null);

export function GetStartedModalProvider({ children }: { children: ReactNode }) {
  const [show, setShow] = useState(false);

  const openGetStartedModal = useCallback(() => setShow(true), []);
  const closeGetStartedModal = useCallback(() => setShow(false), []);

  const value = useMemo(
    () => ({
      show,
      openGetStartedModal,
      closeGetStartedModal,
    }),
    [show, openGetStartedModal, closeGetStartedModal],
  );

  return (
    <GetStartedModalContext.Provider value={value}>{children}</GetStartedModalContext.Provider>
  );
}

export function useGetStartedModal(): GetStartedModalContextValue {
  const context = useContext(GetStartedModalContext);

  if (!context) {
    throw new Error('useGetStartedModal must be used within GetStartedModalProvider');
  }

  return context;
}
